import { customNumericSort, formattedRupee, StoreUtils } from 'utils/util';
import { SBankDetails, SContraVoucherData, SEntryData, STransaction } from './types';
import { DateConst } from 'utils/date';
import { ColorCell } from 'components/Table/MRTTable/CustomCell';

export const CashAndBankBookTableColumn = [
  {
    accessorKey: 'index',
    header: '#',
    maxSize: 10,
    enableColumnFilter: false,
  },
  {
    accessorKey: 'name',
    header: 'Item',
  },
  {
    accessorKey: 'accountNo',
    header: 'Account No',
  },
  ...(StoreUtils.getKeyFromActiveSession(['config', 'tallyIntegrationV2'])
    ? [
        {
          accessorKey: 'isTallySynced',
          header: 'Tally Synced',
          accessorFn: (row: STransaction) => (row.isTallySynced ? 'Yes' : 'No'),
          Cell: ({ row }: { row: { original: STransaction } }) => (
            <ColorCell
              value={row.original.isTallySynced ? 'Yes' : 'No'}
              color={row.original.isTallySynced ? '#00ac56' : '#d32926'}
            />
          ),
          sortingFn: customNumericSort,
          filterVariant: 'select',
          filterSelectOptions: ['Yes', 'No'],
        },
      ]
    : []),
  {
    accessorKey: 'in',
    header: 'In',
    accessorFn: (row: STransaction) => formattedRupee(row.in),
  },
  {
    accessorKey: 'out',
    header: 'Out',
    accessorFn: (row: STransaction) => formattedRupee(row.out),
  },
  {
    accessorKey: 'net',
    header: 'Net',
    accessorFn: (row: STransaction) => formattedRupee(row.net),
  },
];

export const indianBanks: string[] = [
  'State Bank of India',
  'ICICI Bank',
  'HDFC Bank',
  'Axis Bank',
  'Punjab National Bank',
  'Bank of Baroda',
  'Canara Bank',
  'Union Bank of India',
  'Bank of India',
  'IndusInd Bank',
  'IDBI Bank',
  'Yes Bank',
  'Kotak Mahindra Bank',
  'Federal Bank',
  'Indian Bank',
  'Bank of Maharashtra',
  'City Union Bank',
  'Karur Vysya Bank',
  'South Indian Bank',
  'UCO Bank',
  'RBL Bank',
  'Dhanlaxmi Bank',
  'Andhra Bank',
  'IDFC FIRST Bank',
  'Indian Overseas Bank',
  'Jammu and Kashmir Bank',
  'Syndicate Bank',
  'Vijaya Bank',
  'Bandhan Bank',
  'Catholic Syrian Bank',
  'Central Bank of India',
  'DCB Bank',
  'Lakshmi Vilas Bank',
  'Nainital Bank',
  'Punjab & Sind Bank',
  'United Bank of India',
  'Equitas Small Finance Bank',
  'Ujjivan Small Finance Bank',
  'AU Small Finance Bank',
  'Paytm Payments Bank',
];

export const BankDetailsInitialState: SBankDetails = {
  name: '',
  isHO: false,
  accountNo: '',
  ifscCode: '',
  openingBal: '',
};

export const ContraVoucherInitialState: SContraVoucherData = {
  from: '',
  to: '',
  amount: '',
  date: DateConst.todayUnix(),
};

export const AddEntryPaymentMode = {
  Card: 'Card',
  Cash: 'Cash',
  Cheque: 'Cheque',
  Paytm: 'Paytm',
  'RTGS/NEFT': 'RTGS/NEFT',
  UPI: 'UPI',
};

export const EntryDataInitialState: SEntryData = {
  paymentType: '',
  amount: '',
  paymentMode: AddEntryPaymentMode.Card,
  refNo: '',
  name: '',
  remark: '',
  date: DateConst.todayUnix(),
};
